export default function checkDateLength(dateInput: string): string {
  const separator = "-";
  const date = dateInput.replace(/\D/g, "");
  const dateLength = date.length;
  let dateOut = "";
  let dateUncertain = null;

  // Check the length of the date and act accordingly
  switch (dateLength) {
    case 8:
      dateOut = date.substr(0, 2) + separator + date.substr(2, 2) + separator + date.substr(4, 4);
      break;
    case 7:
    case 5:
      // Run first 3 digits through logic
      dateUncertain = uncertainLogic(date.substr(0, 3), separator);
      if (dateUncertain !== null) {
        dateOut = dateUncertain + separator + buildYear(date.substr(3, 4));
      } else {
        dateOut = requestClarification(date, separator);
      }
      break;
    case 6:
      if (convertToNumber(date.substr(2, 4)) > 1300) {
        dateOut =
          padDigits(date.substr(0, 1)) +
          separator +
          padDigits(date.substr(1, 1)) +
          separator +
          buildYear(date.substr(4, 4));
      } else {
        dateOut =
          padDigits(date.substr(0, 2)) +
          separator +
          padDigits(date.substr(2, 2)) +
          separator +
          buildYear(date.substr(4, 2));
      }
      break;
    case 4:
      dateOut =
        padDigits(date.substr(0, 1)) +
        separator +
        padDigits(date.substr(1, 1)) +
        separator +
        buildYear(date.substr(2, 2));
      break;
    default:
      return dateInput;
  }
  return dateOut;
}

function padDigits(digits: string) {
  if (digits.length < 2) {
    digits = "0" + digits;
  }
  return digits;
}

function buildYear(digits: string) {
  if (digits.length < 3) {
    // Note: when the input is a 2 digit year, the century is assumed
    const digitsNumber = convertToNumber(digits);
    if (digitsNumber < 20) {
      digits = "20" + digits;
    } else {
      digits = "19" + digits;
    }
  }
  return digits;
}

function uncertainLogic(digits: string, separator: string) {
  if (convertToNumber(digits.substr(1, 2)) > 12) {
    // Can't be a month
    return padDigits(digits.substr(0, 2)) + separator + padDigits(digits.substr(2, 1));
  } else if (convertToNumber(digits.substr(0, 2)) > 31) {
    // Can't be a day
    return padDigits(digits.substr(0, 1)) + separator + padDigits(digits.substr(1, 2));
  } else {
    // Can't be sure, request clarification
    return null;
  }
}

function requestClarification(digits: string, separator: string) {
  let yearLength;
  if (digits.length > 5) {
    yearLength = 4;
  } else {
    yearLength = 2;
  }

  const month = convertToNumber(padDigits(digits.substr(2, 1)));

  if (month < 1 || month > 12) {
    // In case of single digit day (e.g. 1101978 -> 01-10-1978)
    return (
      padDigits(digits.substr(0, 1)) +
      separator +
      padDigits(digits.substr(1, 2)) +
      separator +
      buildYear(digits.substr(3, yearLength))
    );
  } else {
    // In case of double digit day (e.g. 1011978 -> 10-01-1978)
    return (
      padDigits(digits.substr(0, 2)) +
      separator +
      padDigits(digits.substr(2, 1)) +
      separator +
      buildYear(digits.substr(3, yearLength))
    );
  }
}

const convertToNumber = (input: string) => parseInt(input, 10);
